export const COUNTRIES_UPDATE = 'COUNTRIES_UPDATE';
export const WORKS_UPDATE = 'WORKS_UPDATE';
export const EDUCATION_UPDATE = 'EDUCATION_UPDATE';
export const USERINFO_UPDATE = 'USERINFO_UPDATE';
export const RESUME_UPDATE = 'RESUME_UPDATE';
export const BANNER_UPDATE = 'BANNER_UPDATE';
export const COMMON_IMAGES = 'COMMON_IMAGES';
export const COMMON_PHONES = 'COMMON_PHONES';
export const COMMON_BANNER = 'COMMON_BANNER';
export const SHOW_ADS = 'SHOW_ADS';
export const SUBTITLES = 'SUBTITLES';
export const SKILL = 'SKILL';
